module.exports = __webpack_public_path__ + "img/CAPTAIN_CAR.5c1a5611.svg";